import { Configuration } from './types';

/**
 * Internal DEV environment configuration.
 * This points at the DEV environment (i.e. all services referenced below are running/hosted in the DEV environment).
 */
export const config: Partial<Configuration> = {
  portalApi: 'https://eca.api.dev.portal.genvis.com/v1',
  mapbox: {
    token: 'pk.eyJ1IjoiZ2VudmlzLW1hbml0b2JhIiwiYSI6ImNtYmVpY2NqazAybm4yaXNoaWlhYXk4a3AifQ.MdoLKim7-5ipgGyEYyDkGg',
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://dev.kudo.genvis.com/assets/icons/map/pins/emo',
    iconAssetsPathPng: 'https://dev.kudo.genvis.com/assets/icons/map/pins/emo/40x40',
  },
  webTemplateStyleSheetUrl: 'https://dev.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  environment: 'dev',
};
